export default function () {
  return {
    products: [],
    addressId: null,
    invoiceId: null,
    deliveryCompany: process.env.DELIVERY_COMPANY,
    orderId: null,
    card: {
      name: null,
      cardNumber: null,
      expirationMonth: null,
      expirationYear: null,
      securityCode: null,
      payments: null
    },
    deviceSession: null,
    items: []
  };
}